
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 20a8 8 0 100-16 8 8 0 000 16zm6.667-8a6.667 6.667 0 11-13.334 0 6.667 6.667 0 0113.334 0zM13 9a1 1 0 11-2 0 1 1 0 012 0zm0 2v5h-2v-5h2z","fill":"#949AA1"}})])
          )
        }
      }
    